import { userInfoStore } from '@pascal/pascal-core/shared/core/store';

export const customLiveBetsSort = (bets) => {
  let myBet = [];
  let others = [];
  const { userId } = userInfoStore;
  if (bets.length) {
    myBet = bets.filter((bet) => !bet?.userId || bet?.userId === +userId);
    others = bets.filter((bet) => bet?.userId && bet?.userId !== +userId);
  }
  myBet = myBet.map((item) => {
    return {
      ...item,
      betData: [...(item?.betData || item?.additionalParams || [])].sort(
        (a, b) => b?.amount - a?.amount
      ),
    };
  });
  others = others.map((item) => {
    return {
      ...item,
      betData: [...(item?.betData || item?.additionalParams || [])].sort(
        (a, b) => b?.coinAmount - a?.coinAmount
      ),
    };
  });

  return [myBet, others];
};
